var _defs, _path, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMyStaffBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Icons",
    "data-name": "Level Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.884,
    height: 75.884,
    viewBox: "0 0 75.884 75.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f6c83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89a3a2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M37.942,75.884A37.942,37.942,0,1,0,0,37.942,37.942,37.942,0,0,0,37.942,75.884Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 46.492,
    height: 46.492,
    transform: "translate(14.602 14.696)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4317",
    "data-name": "Group 4317",
    transform: "translate(14.14 21.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M455.95,522.793a10.09,10.09,0,1,1,10.09-10.09A10.09,10.09,0,0,1,455.95,522.793Zm0-18.449a8.36,8.36,0,1,0,8.36,8.36A8.36,8.36,0,0,0,455.95,504.344Z",
    transform: "translate(-441.071 -502.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761_-_Outline",
    "data-name": "Path 5761 - Outline",
    d: "M456.166,523.473h0a10.554,10.554,0,1,1,10.555-10.555A10.566,10.566,0,0,1,456.165,523.473Zm0-20.179a9.625,9.625,0,1,0,9.625,9.624A9.635,9.635,0,0,0,456.165,503.294Zm0,18.449a8.825,8.825,0,0,1,0-17.649h0a8.825,8.825,0,0,1,0,17.649Zm0-16.72a7.895,7.895,0,1,0,7.9,7.895,7.9,7.9,0,0,0-7.9-7.895Z",
    transform: "translate(-441.286 -502.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M443.354,529.226a.894.894,0,0,1-.456-.133.87.87,0,0,1-.276-1.193l3.061-4.9a5.142,5.142,0,0,1,4.382-2.422h13.767a5.189,5.189,0,0,1,4.3,2.306l3.332,5a.865.865,0,0,1-1.4,1.013c-.012-.017-.023-.034-.033-.05l-3.338-5a3.461,3.461,0,0,0-2.883-1.528H450.07a3.407,3.407,0,0,0-2.883,1.609l-3.061,4.9A.872.872,0,0,1,443.354,529.226Z",
    transform: "translate(-442.028 -497.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762_-_Outline",
    "data-name": "Path 5762 - Outline",
    d: "M470.974,529.938a1.335,1.335,0,0,1-1.078-.55l-.006-.008c-.015-.021-.029-.042-.042-.063l-3.333-5A2.992,2.992,0,0,0,464.028,523H450.284a2.926,2.926,0,0,0-2.488,1.39l-3.062,4.9a1.329,1.329,0,0,1-1.18.616,1.362,1.362,0,0,1-.686-.2,1.34,1.34,0,0,1-.427-1.833l3.063-4.9a5.574,5.574,0,0,1,4.757-2.641h13.786a5.647,5.647,0,0,1,4.682,2.513l3.328,5a1.33,1.33,0,0,1-1.083,2.1Zm-.323-1.093a.4.4,0,0,0,.647-.471l-.01-.014-3.332-5a4.717,4.717,0,0,0-3.91-2.1H450.26a4.65,4.65,0,0,0-3.968,2.2l-3.062,4.9a.406.406,0,0,0,.13.553.427.427,0,0,0,.215.062h.032a.405.405,0,0,0,.341-.186l3.058-4.894a3.851,3.851,0,0,1,3.276-1.828h13.746a3.921,3.921,0,0,1,3.258,1.734l3.349,5.021Z",
    transform: "translate(-442.242 -497.259)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(25.453 3.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761-2",
    "data-name": "Path 5761",
    d: "M453.082,517.056a7.221,7.221,0,1,1,7.221-7.221A7.222,7.222,0,0,1,453.082,517.056Zm0-13.2a5.983,5.983,0,1,0,5.983,5.983A5.984,5.984,0,0,0,453.082,503.852Z",
    transform: "translate(-442.115 -501.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761_-_Outline-2",
    "data-name": "Path 5761 - Outline",
    d: "M453.384,518.008h0a7.872,7.872,0,1,1,7.872-7.872A7.881,7.881,0,0,1,453.383,518.008Zm0-13.2a5.332,5.332,0,1,0,5.333,5.332,5.338,5.338,0,0,0-5.333-5.332Z",
    transform: "translate(-442.416 -502.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762-2",
    "data-name": "Path 5762",
    d: "M443.109,526.767a.641.641,0,0,1-.326-.1.622.622,0,0,1-.2-.854l2.191-3.507a3.68,3.68,0,0,1,3.136-1.733h9.853a3.714,3.714,0,0,1,3.074,1.651l2.385,3.581a.619.619,0,0,1-1,.725l-.024-.036-2.389-3.581a2.477,2.477,0,0,0-2.063-1.094h-9.829a2.438,2.438,0,0,0-2.063,1.152l-2.191,3.507A.623.623,0,0,1,443.109,526.767Z",
    transform: "translate(-441.842 -502.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762_-_Outline-2",
    "data-name": "Path 5762 - Outline",
    d: "M463.023,527.742a1.274,1.274,0,0,1-1.029-.525c-.018-.025-.031-.045-.044-.065l-2.383-3.573a1.823,1.823,0,0,0-1.514-.8h-9.837a1.777,1.777,0,0,0-1.51.844l-2.2,3.517a1.273,1.273,0,0,1-1.12.582,1.294,1.294,0,0,1-.647-.192,1.278,1.278,0,0,1-.41-1.75l2.193-3.51a4.306,4.306,0,0,1,3.674-2.039h9.867a4.359,4.359,0,0,1,3.615,1.94l2.38,3.574a1.27,1.27,0,0,1-1.037,2Z",
    transform: "translate(-442.142 -502.632)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyStaffBig);
export default __webpack_public_path__ + "static/media/icon_my_staff_big.3b4afaf773e4c0643eb0385839b72c4a.svg";
export { ForwardRef as ReactComponent };